import { isYes } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';
import { useFormContext } from 'modules/client/legal/forms/companyLicenseForm';

import { FormContent } from './FormContent';

export const CompanyLicenseSection = () => {
  const { t } = useTranslation();
  const { values, setFieldValue, readOnly } = useFormContext();

  const onAdd = () => {
    const licenses = [
      ...values.companyLicense.licenses,
      {
        authorityName: '',
        dateOfExpiry: undefined,
        dateOfIssue: undefined,
        licensedActivityType: '',
        licenseNumber: '',
        files: [],
      },
    ];

    setFieldValue(
      'companyLicense',
      {
        ...values.companyLicense,
        licenses,
      },
      false
    );
  };

  const onRemove = (index: number) => {
    const licenses = [...values.companyLicense.licenses];
    licenses.splice(index, 1);
    setFieldValue(
      'companyLicense',
      {
        ...values.companyLicense,
        licenses,
      },
      false
    );
  };

  return (
    <Section
      datax="companyLicenseSection"
      headerRight={
        !readOnly &&
        isYes(values.companyLicense.companyActivityIsLicensed) && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAdd}
          />
        )
      }
      title={t('client.legal.companyLicense.title')}
    >
      <FormContent onRemove={onRemove} />
    </Section>
  );
};
